(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("pullrefresh", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["pullrefresh"] = factory(require("vue"));
	else
		root["pullrefresh"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8__) {
return 